export enum ControlTypes  {
  Text = "Text",
  Number = "Number",
  TextArea = "TextArea",
  RichText = "RichText",
  RadioButton = "RadioButton",
  Date = "Date",
  RatingSelector = "RatingSelector",
}